import { useState, useEffect, useRef } from "react";
import { Spin } from "antd";
import PropTypes from "prop-types";

const useOnScreen = (ref) => {
	const [isIntersecting, setIntersecting] = useState(false);

	const observer = new IntersectionObserver(([entry]) =>
		setIntersecting(entry.isIntersecting)
	);

	useEffect(() => {
		observer.observe(ref.current);

		return () => {
			observer.disconnect();
		};
	}, []);

	return isIntersecting;
};

const Component = ({ loading, onScreen }) => {
	const ref = useRef();
	const isOnScreen = useOnScreen(ref);

	const componentDidUpdate = () => {
		if (isOnScreen) onScreen();
	};

	useEffect(componentDidUpdate, [isOnScreen]);

	return (
		<span
			ref={ref}
			className="bk-loadmore"
		>
			<Spin />
		</span>
	);
};

Component.propTypes = {
	loading: PropTypes.any,
	onScreen: PropTypes.func.isRequired,
};

export default Component;
